<template>
        <v-select
          v-model="selecteddDataV"
          :items="data"
          :label="rowname"
          @change="selectSearch(selecteddDataV), $emit('input', selecteddDataV)"
          :multiple="multiple"
          :item-text="item => trans(item['name'])"
          item-value="id"
          outlined
          hide-details=true
          dense
          @input="selecteddDataV=$event?$event:''"
          :clearable="multiple ? false : true"
        >    
            <template v-slot:selection="{ item, index }">
                <v-chip
                    color="primary"
                    v-if="index === 0"
                    small
                    outlined
                >
                    <strong v-if="item.short">{{ trans(item.short) }}</strong>
                    <strong v-else>{{ trans(item.name) }}</strong>
                </v-chip>
                <span
                    v-if="index === 1"
                    class="grey--text caption"
                    >
                    +{{ selecteddDataV.length - 1 }}
                </span>
            </template>
        </v-select>
</template>

<script>
  export default {
    props: ['rowdata', 'rowname', 'selecteddData'],
    data () {
      return {
        selecteddDataV: this.selecteddData,
        data: this.rowdata,
        multiple: true,
      }
    },
    methods: {
        selectSearch(finalData){
            if(this.rowname == 'Time' || this.rowname  == 'Vaxt' || this.rowname  == 'Время'){
                this.$parent.$root.timeSearch(finalData);
            }else if(this.rowname == 'Category' || this.rowname  == 'Kateqoriya' || this.rowname  == 'Категория'){
                this.$parent.$root.categorySearch(finalData);
            }else if(this.rowname == 'City' || this.rowname  == 'Şəhər' || this.rowname  == 'Город'){
                this.$parent.$root.citySearch(finalData);
            }else if(this.rowname == 'District' || this.rowname  == 'Rayon' || this.rowname  == 'Район'){
                this.$parent.$root.districtSearch(finalData);
            }
        },
    },
    mounted() {
            if(this.rowname == 'City' || this.rowname == 'Şəhər' || this.rowname == 'Город'){
                //this.multiple = false;
            }
        }
  }
</script>